import React from "react";
import ReactDOM from "react-dom/client"; // ✅ Correct import for React 18
import "tailwindcss/tailwind.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Analytics } from "@vercel/analytics/react"

// Create root and render App
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>
);

// Register service worker
serviceWorker.unregister();
